/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.PaymentController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { PaymentDataModel } from '../models/payment-data-model';
import { PaymentStatusResponse } from '../models/payment-status-response';

@Injectable()
export class PaymentApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getPaymentMetaData(caseId: number, spinnerMessage: string = null): Observable<PaymentDataModel> {
        return this.httpClient.get<PaymentDataModel>(`/api/payment/meta?caseId=${caseId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getPaymentStatus(caseId: number, spinnerMessage: string = null): Observable<PaymentStatusResponse> {
        return this.httpClient.get<PaymentStatusResponse>(`/api/payment/status?caseId=${caseId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public getReRegistrationPaymentStatus(caseId: number, spinnerMessage: string = null): Observable<PaymentStatusResponse> {
        return this.httpClient.get<PaymentStatusResponse>(`/api/payment/reregistrationstatus?caseId=${caseId}`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


    public setPaymentMetaData(paymentDataModel: PaymentDataModel, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/payment/meta`, paymentDataModel,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public startGbmPayment(caseId: number, spinnerMessage: string = null): Observable<string> {
        return this.httpClient.post<string>(`/api/payment/start?caseId=${caseId}`, null,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
